export const API_PATH_ApiWWRStartZipFileCreationV2 = '/services/wrong-way-resolution/apiWWRStartZipFileCreation-v2';
